import type { OutreachCandidate } from '../../types/taOutreach';

/**
 * A colleague's open drafts signed for them (`sentAsOther`): "Update all" signs them for the viewer
 * too (Sofia, Oct 28 2026: the button said "2 / 2" while every card still said Luisa). An outdated
 * one is redrafted instead (it is in the outdated rows already).
 */
export const colleaguesSigned = (items: OutreachCandidate[]) =>
  items.filter((c) => c.sentAsOther && !c.sentAsStale && !c.draftOutdated && (c.status === 'drafted' || c.status === 'ready'));

/**
 * Run `fn` for every id, `parallel` at a time (Update all, Sofia, Oct 28 2026: two redrafts one after
 * the other took ~55 s). Each lane takes the next id when its last one is done; order is kept per lane.
 */
export async function runInLanes(ids: string[], fn: (id: string) => Promise<void>, parallel = 1) {
  const todo = [...ids];
  const lane = async () => {
    for (let id = todo.shift(); id !== undefined; id = todo.shift()) await fn(id);
  };
  await Promise.all(Array.from({ length: Math.max(1, Math.min(parallel, todo.length)) }, lane));
}
